import React from "react"
import _ from "lodash"
import Isvg from 'react-inlinesvg'
import { CloseIcon } from 'images/icons/general'
import { ClearDropdown_s, TableDropdown_s } from 'styles/input-styles'
import { local } from 'data/lib/local-json'

export type DropdownInterface = {
  attrs?: Function
  disabled?: boolean
  rowData: {}
  rowId?: string
  field: string|string[]
  filter?: boolean
  options: Array<{label: string, value: string}> | string[]
  persist: Function
  className?: string
  default?: string
  onClear?: Function
}

const NamedItemEdit = (props: DropdownInterface) => {
  const table = local('tableid').replace(/table/g, "").replace(/-/g, "")
  const attrs = (props.attrs && props.attrs(props.field)) || {}
  const value = !_.isNil(_.get(props.rowData, props.field)) ? _.get(props.rowData, props.field) : props.default ? props.default : null
  // Don't allow current row to be an option (example: Market lease - subsequent market)
  const options = props.rowId ? _.filter(props.options, (opt) => opt.value !== props.rowData[props.rowId!]) : props.options

  return (
    <div
      style={{display: 'flex'}}
      data-id={props.rowData[`${table}id`]}
      data-field={props.field}
      {...attrs}
    >
      <TableDropdown_s
        className={props.className}
        disabled={props.disabled || false}
        value={value}
        options={options}
        onChange={e => props.persist(e.value, props.field, props.rowData)}
        filter={props.filter || false}
      />
      { props.onClear && !_.isNil(value) && <ClearDropdown_s onClick={props.onClear}><Isvg src={CloseIcon} /></ClearDropdown_s>}
    </div>
  )
}

export default NamedItemEdit
